import * as React from "react";
import { styled } from "@mui/system";
import MUITableHead from "@mui/material/TableHead";
import { TableHeadProps as TableHeadPropsMUI } from "@mui/material/TableHead";
import { OverridableComponent } from "@mui/material/OverridableComponent";

export interface TableHeadProps extends TableHeadPropsMUI {
  shadow?: boolean;
  component?: React.ElementType;
}

const TableHeadRoot = styled(
  React.forwardRef<HTMLTableSectionElement, TableHeadProps>((props, ref) => {
    return <MUITableHead ref={ref} {...props} />;
  }),
  {
    name: "TableHead",
    slot: "Root",
    shouldForwardProp: (prop) => prop !== "shadow" && prop !== "myProp",
    overridesResolver: (props, styles) => []
  }
)(({ theme, shadow }) => ({
  "&.MuiTableHead-root": {
    background: theme.palette.primary.surfaceDefault,
    boxShadow: shadow ? theme.shadows[3] : "none"
  },
  "&.MuiTableHead-root .MuiTableCell-root.MuiTableCell-head": {
    padding: 8
  }
}));

export interface TableHeadTypeMap<
  AdditionalProps = {},
  RootComponent extends React.ElementType = "thead"
> {
  props: AdditionalProps & TableHeadProps;
  defaultComponent: RootComponent;
}

export const TableHead = React.forwardRef<
  HTMLTableSectionElement,
  TableHeadProps
>(function TableHead(props, ref) {
  return <TableHeadRoot {...props} ref={ref} />;
}) as OverridableComponent<TableHeadTypeMap<{}, "thead">>;
